import { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Icon, Skeleton } from "@chakra-ui/react";

import { SbpIcon } from "../../../icons";
import { RoutesMap } from "../../../../routes.tsx";
import { useCheckActiveSbpTransferQuery } from "../../../../api/sbpTransfer";

interface Props {
  isCoolingFetching: boolean;
  isCoolingActive: boolean | undefined;
}

export const MainPageSbpTransferButton: FC<Props> = ({ isCoolingFetching, isCoolingActive }) => {
  const {
    data: activeSbpTransfer,
    isFetching: isActiveSbpTransferFetching,
  } = useCheckActiveSbpTransferQuery();

  const isDisabled = isCoolingActive || activeSbpTransfer?.isTrancheActive === true;

  if (isCoolingFetching || isActiveSbpTransferFetching) {
    return <Skeleton h="52px" />;
  }

  return (
    <Button
      as={RouterLink}
      to={RoutesMap.sbpTransfer.index}
      w="100%"
      colorScheme="purple"
      isDisabled={isDisabled}
    >
      Перевести

      <Icon as={SbpIcon} w="14px" h="17px" ml="7px" isDisabled={isDisabled} />
    </Button>
  );
};
